import { useSyncExternalStore } from 'react';

import { useAirModal } from '@air/provider-modal';

import { CreditsDepletedModal } from '~/components/Modals/CreditsDepletedModal';
import {
  isDevCreditStatsDepletedOverrideActive,
  subscribeToDevCreditStatsOverride,
} from '~/hooks/utils/devCreditStatsOverride';
import { useCreditStats } from '~/swr-hooks/workspaces/useCreditStats';

export const useCanConsumeMoreCredits = () => {
  const { data: creditStats } = useCreditStats();
  const [showCreditsDepletedModal] = useAirModal(CreditsDepletedModal);

  const isDevDepletedOverrideActive = useSyncExternalStore(
    subscribeToDevCreditStatsOverride,
    isDevCreditStatsDepletedOverrideActive,
    () => false,
  );

  const apiCanConsumeMoreCredits = creditStats?.canConsumeMoreCredits !== false;

  const canConsumeMoreCredits = isDevDepletedOverrideActive ? false : apiCanConsumeMoreCredits;

  return {
    apiCanConsumeMoreCredits,
    canConsumeMoreCredits,
    showCreditsDepletedModal,
  };
};
